<template>
	<div class="meidum-b">
		<div class="meidum">
			<div class="ry-cc">
				<el-carousel height="360px" style="background-color: #f2f2f2;" :interval="5000" arrow="always" indicator-position="none">
				    <el-carousel-item  v-for="item in list2" :key="item">
						<div class="ry-b-c1" >
							<div class="item" v-for="item1 in item" 
							style="" @click="tapDetails(item1)">  
							   <img class="item-h" :src="item1.barticleUrl" alt="">
								<div class="t" style="display: -webkit-box;
    -webkit-line-clamp: 1; /* 限制为3行 */
    -webkit-box-orient: vertical;
    overflow: hidden;">{{item1.barticleTile}}</div>
								<div class="s11" >{{item1.createTime.split('00:00:00')[0]}}</div>
							</div>
						</div>
				    </el-carousel-item>
				  </el-carousel>
			</div>
		</div>
		<div class="meidum1">
			<div class="meidum1-c">
				<div class="item" v-for="(item, index) in list1" :key="index"
				@click="tapDetails(item)">
					<img class="item-l" :src="item.barticleUrl" alt="">
					<div class="item-r">
						<div class="title1">{{item.barticleTile}}
						<div class="sec1">{{item.content1}}</div>
						</div>
					    <div class="footer1">
					    	<div class="time">{{item.createTime.split('00:00:00')[0]}}</div>
							<div class="detail">查看全部内容</div>
					    </div>
					</div>
					
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list1: {
				type: Array,
				default: []
			},
			list2: {
				type: Array,
				default: []
			}
		},
		watch:{
			
		},
		data() {
			return {
				selectIndex: 0

			}
		},
		created() {

		},
		methods: {
			tapList(index) {
				this.selectIndex = index
			},
			
			tapDetails(item) {
				this.$router.push({path:"/en/mediumdetails", query:{ id: item.bid }}) 
			}
			

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	
	.el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 200px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: rgba(0, 0, 0, 0);
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: rgba(0, 0, 0, 0);
	  }
	  

    .meidum1 {
		background-color: #fff;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		
		.meidum1-c {
			.item {
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #f1f1f1;
				padding: 12px 0;
				.item-l {
					
				}
				.item-r {
					
					flex-direction: column;
					justify-content: space-between;
					padding: 20px 0;
					.title1 {
						color: #332C2B;
					}
					.sec1 {
						color: #666666;
						display: -webkit-box;
						  -webkit-box-orient: vertical;
						  -webkit-line-clamp: 4;
						  overflow: hidden;
						  text-overflow: ellipsis;
					}
					.footer1 {
						justify-content: flex-start;
						align-items: center;
						.time {
						
							color: #999999;
							border-right: 1px solid #f1f1f1;
						}
						.detail {
							
							color: #008D8E;
						}
						
						
					}
				}
			}
		}
	}
	
	.meidum {
		background-color: #F3F9F9;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;

		.ry-cc {
			height: 400px;
		}

		
			.ry-b-c1 {
				width: 100%;
				padding: 0px 60px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				
				.item {
					transition: transform 0.3s;
					width: calc(33.3% - 15px);
					flex-direction: column;
					justify-content: center;
					align-items: center;
					text-align: left;
					margin: 0 8px;

					.item-h {
						width: 100%;
						height: 216px;
					}

					.t {
						color: #332C2B;
						width: 100%;
						font-size: 18px;
						margin-top: 16px;
						
					}

					.s11 {
						text-align: left;
						color: #999999;
						font-size: 16px;
						margin-top: 10px;
					}

				}
				.item:hover {
				 transition: width 0.3s, height 0.3s;
				 transform: scale(0.95);
				 
				}

			}


		


	}
	
	@media screen and (min-width: 1200px) {
		.meidum1 {
			width: 100%;
			display: flex;
			padding-bottom: 80px;
			padding-top: 80px;
			
			.meidum1-c {
				width: 1200px;
				
				.item {
					width: 100%;
					padding: 80px 0 60px;
					display: flex;
					border-bottom: 1px solid #f1f1f1;
					.item-l {
						width: 480px;
						height: 320px;
					}
					.item-r {
						width: calc(100% - 570px);
						height: 320px;
						display: flex;
						.title1 {
							font-size: 22px;
						}
						.sec1 {
							margin-top: 34px;
							font-size: 17px;
						}
						.footer1 {
							display: flex;
							.time {
								width: 200px;
								height: 22px;
								font-size: 16px;
								border-right: 1px solid #f1f1f1;
							}
							.detail {
								margin-left: 30px;
								font-size: 16px;
							}
							
							
						}
					}
				}
			}
		}
		
		.meidum {
			width: 100%;
			display: flex;
			padding-bottom: 80px;
			padding-top: 80px;
		
			.ry-cc {
				width: 1320px;
			}
		
			
		
				
					
		}
	
	}
	@media screen and (max-width: 1200px) {
		.meidum1 {
			width: 100%;
			display: flex;
			padding: 60px 30px;
			
			.meidum1-c {
				width: 100%;
				
				.item {
					width: 100%;
					padding: 40px 0 40px;
					display: flex;
					border-bottom: 1px solid #f1f1f1;
					.item-l {
						width: 400px;
						height: 280px;
						background-color: #332C2B;
					}
					.item-r {
						width: calc(100% - 440px);
						height: 300px;
						display: flex;
						.title1 {
							font-size: 20px;
						}
						.sec1 {
							margin-top: 28px;
							font-size: 16px;
						}
						.footer1 {
							display: flex;
							.time {
								width: 180px;
								height: 22px;
								font-size: 14px;
								border-right: 1px solid #f1f1f1;
							}
							.detail {
								margin-left: 24px;
								font-size: 14px;
							}
							
							
						}
					}
				}
			}
		}
		
		.meidum {
			width: 100%;
			display: flex;
			padding: 40px 20px 10px;
		
			.ry-cc {
				width: 100%;
			}
		
			
		
				.ry-b-c1 {
					width: 100%;
					padding: 0px 50px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					
					.el-carousel__item:nth-child(2n) {
					  background-color: #F3F9F9;
					}
					
					.el-carousel__item:nth-child(2n+1) {
					  background-color: #F3F9F9;
					}
					
					
					.item {
						width: calc(33.3% - 15px);
						flex-direction: column;
						justify-content: center;
						align-items: center;
						text-align: left;
				
						.item-h {
							width: 100%;
						}
				
						.t {
							color: #332C2B;
							width: 100%;
							font-size: 18px;
							margin-top: 12px;
							
						}
				
						.s11 {
							text-align: left;
							color: #999999;
							font-size: 14px;
							margin-top: 8px;
						}
				
					}
				
				}		
					
		}
	
	}
	@media screen and (max-width: 880px) {
		.meidum1 {
			width: 100%;
			display: flex;
			padding: 30px 12px 10px;
			
			.meidum1-c {
				width: 100%;
				
				.item {
					width: 100%;
					padding: 12px 0 12px;
					display: flex;
					border-bottom: 1px solid #f1f1f1;
					.item-l {
						width: 40%;
						height: 160px;
						background-color: #332C2B;
					}
					.item-r {
						width: calc(60% - 10px);
						height: 160px;  
						display: flex;
						.title1 {
							font-size: 15px;
						}
						.sec1 {
							margin-top: 6px;
							font-size: 14px;
						}
						.footer1 {
							display: flex;
							.time {
								width: 100px;
								height: 22px;
								font-size: 13px;
								border-right: 1px solid #f1f1f1;
							}
							.detail {
								margin-left: 12px;
								font-size: 13px;
							}
							
							
						}
					}
				}
			}
		}
		
		.meidum {
			display: none;
		}
		
		
				
		.ry-b-c {
			width: 100%;
			display: flex;	
				padding: 0 12px;
			.item {
				width: calc(33.3% - 12px);
				display: flex;
				
				.item-h {
					width: 100%;
					height: 180px;
				}
				
				.t {
					margin-top: 12px;
					font-size: 16px;
				}
				
				.s11 {
					width: 100%;
					margin-top: 12px;
					font-size: 13px;
				}
			}		
		}
	
	}
</style>
